<div class="dialog-wrapper" [formGroup]="stepOneFormGroup">
    <div style="height: 12vh;">
    <div>
      <label i18n="@@wordTemplateTitle" class="textColour" [ngStyle]="{'border-color':buttonColor}">
        {{titleText}}
      </label>
      <span class="example-spacer"></span>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">

    <!-- Radio buttons -->
    <mat-radio-group formControlName="mode" class="mb-4 d-flex" (change)="onModeChange()">
      <mat-radio-button disableRipple value="new" class="mr-4">New</mat-radio-button>
      <mat-radio-button disableRipple value="copy" class="mr-4">Select Template to Copy</mat-radio-button>
    </mat-radio-group>

    <!-- Dropdown only if copy -->
    <div *ngIf="stepOneFormGroup.get('mode')!.value === 'copy'" class="mt-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Select Template</mat-label>
        <mat-select formControlName="templateId">
          <mat-option *ngFor="let t of templates" [value]="t.templateName">
            {{ t.templateName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="backgroundColorButton"
       style="padding:4px 14px; font-size:13px; min-width:80px; height:34px;"
      (click)="cancel()">
      Cancel
    </button>

    <button
      class="download-btn btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="backgroundColorButton"
      (click)="submit()"
      [disabled]="stepOneFormGroup.get('mode')!.value === 'copy' && !stepOneFormGroup.get('templateId')!.value"
       style="padding:4px 14px; font-size:13px; min-width:80px; height:34px;">
      Continue
    </button>
  </mat-dialog-actions>
</div>
